import { Routes } from '@angular/router';

export const loginRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "login-view.async" */
                './login-view.component'
            ).then(m => m.LoginViewComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "login-form.async" */
                        './login-form.component'
                    ).then(m => m.LoginFormComponent)
            },
            {
                path: 'reset-password',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "login-reset-password.async" */
                        './login-reset-password.component'
                    ).then(m => m.LoginResetPasswordComponent)
            }
        ]
    }
];
